import { Component, OnInit, Inject, ViewChild, ElementRef  } from '@angular/core';
import { DlgTrabajandoComponent } from '../dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../dlg-error/dlg-error.component';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import {Location} from '@angular/common';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort} from '@angular/material/sort'
import { MatTableDataSource} from '@angular/material/table'
import {MatDialogRef} from '@angular/material/dialog';
import { funciones } from '../../../app/funciones';

@Component({
  selector: 'app-dlg-busquedas',
  templateUrl: './dlg-busquedas.component.html',
  styleUrls: ['./dlg-busquedas.component.css']
})
export class DlgBusquedasComponent implements OnInit {

  lblTitBusqueda="";
  codBusqueda="";
  txtBusc="";
  idGeneral="";
  general="";
  anexo1="";
  escondeTabla: boolean = true;

  dataSourceDATOS = new MatTableDataSource();
  @ViewChild('paginador') paginador: MatPaginator;

  displayedColumnsCONSORCIO: string[] = ['nombre'];
  displayedColumnsMAIL: string[] = ['nombre'];
  
  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgBusquedasComponent>
  ) { }

  ngOnInit(): void {
    this.buscarTxt();
  }

  buscarTxt(){
    if (this.codBusqueda=="CONSORCIO"){
      this.buscarConsorcio();
    }else if (this.codBusqueda=="MAIL"){
      this.buscarMail();
    }
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  seleccionarFila(fila){
    this.thisDialogRef.close(fila);
  }

  buscarConsorcio(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando los consorcios que coincidan con la búsqueda";

    this.httpClient.get(environment.servidorHttp+'Sistema/buscarConsorcio'
      ,{
        params: {
          "idConexion": this.storage.get("idConexion"),
          "soloHabilitados": "1",
          "busqueda": this.txtBusc,
          },
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto']=="01"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los consorcios";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
      }else if (data['resultado']['msgError']['valorDevuelto']=="10"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los consorcios";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
        this.router.navigate(['/']);
      } else{
        if (data['resultado']['datos']!=undefined){
          this.escondeTabla=false;
          this.dataSourceDATOS=new MatTableDataSource<any>(data['resultado']['datos']);
          this.dataSourceDATOS.paginator = this.paginador;
          this.paginador._intl.itemsPerPageLabel = 'Consorcios por hoja';
          this.paginador._intl.nextPageLabel  = 'Proxima hoja';
          this.paginador._intl.previousPageLabel  = 'Hoja anterior';
          this.paginador._intl.lastPageLabel  = 'Última hoja';
          this.paginador._intl.firstPageLabel  = 'Primera hoja';
          this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
          }
        }else{
          this.escondeTabla=true;
        }
      }
    },
    (error: HttpErrorResponse) => {
      this.cerrarDialogo(dlgTrabajando);
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      if (error.status.toString()=="401"){
        dlgError.componentInstance.titulo="Error al buscar los consorcios";
        dlgError.componentInstance.texto="Su sesión ha finalizado";
        this.router.navigate(['/']);
      }else{
        dlgError.componentInstance.titulo="Error al buscar los consorcios";
        dlgError.componentInstance.texto=error.message+" ("+error.status+")";
      }
    });
  }

  buscarMail(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando los mails que coincidan con la búsqueda";

    this.httpClient.get(environment.servidorHttp+'Sistema/buscarMail'
      ,{
        params: {
          "idConexion": this.storage.get("idConexion"),
          "soloHabilitados": "1",
          "busqueda": this.txtBusc,
          },
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto']=="01"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los mails";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
      }else if (data['resultado']['msgError']['valorDevuelto']=="10"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los mails";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
        this.router.navigate(['/']);
      } else{
        if (data['resultado']['datos']!=undefined){
          this.escondeTabla=false;
          this.dataSourceDATOS=new MatTableDataSource<any>(data['resultado']['datos']);
          this.dataSourceDATOS.paginator = this.paginador;
          this.paginador._intl.itemsPerPageLabel = 'Mails por hoja';
          this.paginador._intl.nextPageLabel  = 'Proxima hoja';
          this.paginador._intl.previousPageLabel  = 'Hoja anterior';
          this.paginador._intl.lastPageLabel  = 'Última hoja';
          this.paginador._intl.firstPageLabel  = 'Primera hoja';
          this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
          }
        }else{
          this.escondeTabla=true;
        }
      }
    },
    (error: HttpErrorResponse) => {
      this.cerrarDialogo(dlgTrabajando);
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      if (error.status.toString()=="401"){
        dlgError.componentInstance.titulo="Error al buscar los mails";
        dlgError.componentInstance.texto="Su sesión ha finalizado";
        this.router.navigate(['/']);
      }else{
        dlgError.componentInstance.titulo="Error al buscar los mails";
        dlgError.componentInstance.texto=error.message+" ("+error.status+")";
      }
    });
  }
}
